module.exports = __webpack_public_path__ + "static/media/live_sports_platform.cbe0de66.jpg";